<div
  [formGroup]="SettingForm"
  class="one"
  [ngClass]="class == true ? 'height-526 one' : 'height-525 one'"
  fxLayout="column"
>
  <h3 style="margin-top: 5px; margin-bottom: 0px" class="text-[14px]">
    <b>
      Enter your name and contact details. These are used on your invoices, receipts, documents and
      reports.
    </b>
  </h3>
  <br />
  <div class="border-line"></div>
  <br />
  <div class="height-524 gap-4 pt-4">
    <div fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field
        appearance="outline"
        class="field-25"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.BARRISTERSNAME),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BARRISTERSNAME),
        }"
      >
        <mat-label>Name</mat-label>
        <input name="BARRISTERSNAME" formControlName="BARRISTERSNAME" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="field-25"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.ABN),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ABN),
        }"
      >
        <mat-label>ABN</mat-label>
        <input name="ABN" formControlName="ABN" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutGap="16px"
      class="first-box"
      fxLayoutAlign="start center"
      fxFlex="1 0 auto"
    >
      <mat-form-field
        appearance="outline"
        class="field-25"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.FAMILYLAWCOURTID),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FAMILYLAWCOURTID),
        }"
      >
        <mat-label>Family Law Court Id</mat-label>
        <input name="FAMILYLAWCOURTID" formControlName="FAMILYLAWCOURTID" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="field-25"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.LRSBOXNUMBER),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LRSBOXNUMBER),
        }"
      >
        <mat-label>LRS Box Number</mat-label>
        <input name="LRSBOXNUMBER" formControlName="LRSBOXNUMBER" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
    </div>
    @if (currentUser?.PRODUCTTYPE === 'Barrister') {
      <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
        <mat-form-field
          appearance="outline"
          class="field-50"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.BARRISTERSNAME),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BARRISTERSNAME),
          }"
        >
          <mat-label>Chambers</mat-label>
          <input name="CHAMBERS" formControlName="CHAMBERS" matInput />
          <mat-icon matSuffix class="secondary-text"></mat-icon>
        </mat-form-field>
      </div>
    }
    <h2 class="my-4 text-[20px]">Address</h2>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxFlex="1 0 auto"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ADDRESS1),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ADDRESS1),
      }"
    >
      <mat-form-field appearance="outline" class="field-50">
        <mat-label>Street</mat-label>
        <input name="ADDRESS1" formControlName="ADDRESS1" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxFlex="1 0 auto"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ADDRESS2),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ADDRESS2),
      }"
    >
      <mat-form-field appearance="outline" class="field-50">
        <mat-label>Street Address 2</mat-label>
        <input name="ADDRESS2" formControlName="ADDRESS2" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  </div> -->
    <div fxLayout="row">
      <div class="field-50" fxLayout="row wrap" fxLayoutGap="16px">
        <mat-form-field
          appearance="outline"
          class="field-33"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.SUBURB),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SUBURB),
          }"
        >
          <mat-label>Suburb</mat-label>
          <input matInput formControlName="SUBURB" />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-33"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.STATE),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STATE),
          }"
        >
          <mat-label>State</mat-label>
          <input matInput formControlName="STATE" />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-33"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.POSTCODE),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.POSTCODE),
          }"
        >
          <mat-label>Post Code</mat-label>
          <input matInput formControlName="POSTCODE" />
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="checkbox-row">
      <mat-checkbox
        class="check_1"
        name="SAMECOPYADDRESS"
        formControlName="SAMECOPYADDRESS"
        (change)="triggerSomeEvent(SettingForm)"
      >
        Copy From Street Address
      </mat-checkbox>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field
        appearance="outline"
        class="field-50"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.POSTALADDRESS1),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.POSTALADDRESS1),
        }"
      >
        <mat-label>Postal</mat-label>
        <input name="POSTALADDRESS1" formControlName="POSTALADDRESS1" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field appearance="outline" class="field-50">
        <mat-label>Postal Address 2</mat-label>
        <input name="POSTALADDRESS2" formControlName="POSTALADDRESS2" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
</div> -->
    <div fxLayout="row">
      <div class="field-50" fxLayout="row wrap" fxLayoutGap="16px">
        <mat-form-field
          appearance="outline"
          class="field-33"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.POSTALSUBURB),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.POSTALSUBURB),
          }"
        >
          <mat-label>Suburb</mat-label>
          <input name="POSTALSUBURB" formControlName="POSTALSUBURB" matInput />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-33"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.POSTALSTATE),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.POSTALSTATE),
          }"
        >
          <mat-label>State</mat-label>
          <input name="POSTALSTATE" formControlName="POSTALSTATE" matInput />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-33"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.POSTALPOSTCODE),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.POSTALPOSTCODE),
          }"
        >
          <mat-label>Post Code</mat-label>
          <input name="POSTALPOSTCODE" formControlName="POSTALPOSTCODE" matInput />
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row">
      <div class="field-50" fxLayout="row wrap" fxLayoutGap="16px">
        <mat-form-field
          appearance="outline"
          class="field-50"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.DXNUMBER),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DXNUMBER),
          }"
        >
          <mat-label>DX Number</mat-label>
          <input name="DXNUMBER" formControlName="DXNUMBER" matInput />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-50"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.DXSUBURB),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DXSUBURB),
          }"
        >
          <mat-label>Suburb</mat-label>
          <input name="DXSUBURB" formControlName="DXSUBURB" matInput />
        </mat-form-field>
      </div>
    </div>
    <h2 class="my-4 text-[20px]">Phone and Email</h2>
    <div fxLayout="row">
      <div class="field-75" fxLayout="row wrap" fxLayoutGap="16px">
        <mat-form-field
          appearance="outline"
          class="field-25"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.PHONE1),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PHONE1),
          }"
        >
          <mat-label>Phone 1</mat-label>
          <input name="PHONE1" formControlName="PHONE1" matInput />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-25"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.PHONE2),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PHONE2),
          }"
        >
          <mat-label>Phone 2</mat-label>
          <input name="PHONE2" formControlName="PHONE2" matInput />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-25"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.FAX1),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FAX1),
          }"
        >
          <mat-label>Fax 1</mat-label>
          <input name="FAX1" formControlName="FAX1" matInput />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-25"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.FAX2),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FAX2),
          }"
        >
          <mat-label>Fax 2</mat-label>
          <input name="FAX2" formControlName="FAX2" matInput />
        </mat-form-field>
      </div>

      <div class="field-25"></div>
    </div>
    <!-- <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
</div> -->

    <div fxLayout="row">
      <!-- 75% CONTAINER -->
      <div class="field-75" fxLayout="row wrap" fxLayoutGap="16px">
        <mat-form-field
          appearance="outline"
          class="field-50"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.FAX1),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FAX1),
          }"
        >
          <mat-label>Email</mat-label>
          <input name="EMAIL" formControlName="EMAIL" matInput />
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-50"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.FAX1),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FAX1),
          }"
        >
          <mat-label>Website</mat-label>
          <input name="WWW" formControlName="WWW" matInput />
        </mat-form-field>
      </div>

      <!-- optional remaining 25% -->
      <div class="field-25"></div>
    </div>
  </div>
</div>
<hr />
<div>
  <mat-dialog-actions class="popup_ftr float-left">
    <button
      id="callApiId"
      class="mainbtn_size"
      matButton="filled"
      color="accent"
      [disabled]="isspiner"
      (click)="saveOD()"
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
  </mat-dialog-actions>
</div>
